import { useContext } from 'react';

import { ModalContext } from '@/context/modal';

export function useModal() {
  const modal = useContext(ModalContext);

  return {
    isOpen: modal.isOpen,
    open: modal.open,
    close: modal.close,
  };
}

export default useModal;
